import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { Zeroconf } from '@ionic-native/zeroconf';
import { Utils } from '../utils/utils';
import { Api } from '../api/api';
import { User } from '../user/user';
import { IPTV } from '../iptv/iptv';

/*
*
*  Gateway Provider
*
*/
@Injectable()
export class Gateway {

    /*
    *    Main URL (setted when found)
    */
    private AirmontGatewayURL   : string = '';

    /*
    *    Main URL Domain
    */
    private AirmontGatewayDomain : string = '';

    /*
    *    Main IP
    */
    private AirmontGatewayIP : string = '';

    private _interval:any;

    /*
    *    Constructor
    */
    constructor(
        private service: Zeroconf,
        public http: HttpClient,
        public utils: Utils,
        public api: Api,
        public user: User,
        public iptv: IPTV,
        public events: Events
    ) {}

    /*
    *    Init method 
    */
    init() {
        this.events.subscribe('user:login', () => {
            this.setSourceOnGateway('connect');
        });

        this.events.subscribe('user:beforeDisconnect', () => {
            this.setSourceOnGateway('disconnect');
        });
    }

    /*
    *    Restart
    */
    restart(force?:boolean) {
        
        if (!force) {
            if (this.getAirmontGatewayDomain()) return false;
        }

        if (this._interval) clearInterval(this._interval);

        this.setAirmontGatewayURL('');
        this.setAirmontGatewayDomain('');
        this.setAirmontGatewayIP('');
        
        let that = this;

        that.stopWatching();
        that.startWatching();

        this._interval = setInterval(function() {
            if (that.getAirmontGatewayDomain()) {
                clearInterval(that._interval);
            } else {
                that.stopWatching();
                that.startWatching();
            }
        }, 2500);
        
    }

    /*
    *    stop
    */
    stop() {
        if (this._interval) clearInterval(this._interval);
        this.stopWatching();
    }





    /*
    *    Return Airmont Gateway URL
    */
    getAirmontGatewayURL () {
        return this.AirmontGatewayURL;
    }

    /*
    *    Return Airmont Gateway domain
    */
    getAirmontGatewayDomain () {
        return this.AirmontGatewayDomain;
    }

    /*
    *    Get IP
    */
    getAirmontGatewayIP() {
        return this.AirmontGatewayIP;
    }

    /*
    *    Set Airmont Gateway URL
    */
    setAirmontGatewayURL (url:string='') {
        this.AirmontGatewayURL = url;
    }  

    /*
    *    Set Airmont Gateway Domain
    */
    setAirmontGatewayDomain (url : string = '') {
        this.AirmontGatewayDomain = url;
    }

    /*
    *    Set Airmont Gataway IP
    */
    setAirmontGatewayIP (ip : string = '') {
        this.AirmontGatewayIP = ip;
    }

    /*
    *    Request Creditentials to Airmont Gateway
    */
    getCreditentials () {
        return new Promise((resolve, reject) => {
            if (!this.AirmontGatewayDomain) reject();
            this.http.get(this.AirmontGatewayDomain + ':8080/ag?user=guest').subscribe((response:any)=>{
                resolve(response);
            },(err) => {
                reject(err);
            });

       });
    }

    /*
    *    Request Creditentials to Airmont Gateway for Admin
    */
    getCreditentialsAdmin () {
        return new Promise((resolve, reject) => {

            this.http.get(this.AirmontGatewayDomain + ':8080/ag?user=admin').subscribe((response:any)=>{
                resolve(response);
            },(err) => {
                reject(err);
            });

       });
    }

   
    /*
    *    setSource On Box
    */
    setSourceOnGateway(action) {

        if (!this.AirmontGatewayDomain) return false;
        if (!this.iptv.box.name) return false;
        if (!this.user.data.id) return false;

        // User type
        let GatewayAGUrl = '';
        
        if (this.user.isGuest()) {
            GatewayAGUrl = this.AirmontGatewayDomain + ':8080/ag?user=guest&action='+action+'&source='+this.iptv.box.name;
        } else {
            GatewayAGUrl = this.AirmontGatewayDomain + ':8080/ag?user=admin&action='+action;
        }

        if (GatewayAGUrl) {
            // Calling
            this.http.get(GatewayAGUrl).subscribe((response:any)=>{},(err) => {});
        }
    }

    /*
    *    Set Airmont Gateway Founded (Success callback)
    */
    setGatewayAsFound () {
        this.events.publish('live:success');
        this.events.publish('gateway:on');
    }

    /*
    *    Stop Zero Conf Watching 
    */
    stopWatching() {
        if (this.utils.isBrowser()) return false;
        this.events.publish('gateway:off');
        this.service.unwatch('_http._tcp.', 'local.');
        this.service.reInit();
    }

    /*
    *    Begin Zero Conf Watching 
    */
    startWatching() {
        if (this.utils.isBrowser()) return false;

        this.service.registerAddressFamily = 'ipv4'; 
        this.service.watchAddressFamily = 'ipv4'; 

        this.service.watch('_http._tcp.', 'local.').subscribe(result => {
            if (this.isValidNetwork(result.service)) {
                this.utils.log('Deeplink::startWatching()::validNetwork');
                this.setAirmontGatewayIP(result.service.ipv4Addresses[0]);
                this.setAirmontGatewayDomain('http://' + result.service.ipv4Addresses[0]);
                this.setAirmontGatewayURL('http://' + result.service.ipv4Addresses[0] + ':' + result.service.port);
                this.setGatewayAsFound();
                this.setSourceOnGateway('connect');
            }
        });
    }

    /*
    *    Check if founded network is Valid
    */
    isValidNetwork (network) {

        if (network.name != 'airmont-gw') return false;
        if (!network.ipv4Addresses[0]) return false;
        if ('http://' + network.ipv4Addresses[0] + ':' + network.port == this.getAirmontGatewayURL()) return false;
        return true;;
    }

}


// WEBPACK FOOTER //
// ./src/providers/gateway/gateway.ts